// extracted by mini-css-extract-plugin
module.exports = {"or":"styles_or__Z4HPu","inputWrap":"styles_inputWrap__1BggU","input":"styles_input__1tIyp"};